import * as layouts from "layouts"
import * as routing from "brandguard/routing"
import * as bgscores from "brandguard/display/scores"
import * as scoring from "./scoring"

export default function Scoring(): JSX.Element {
	return (
		<bgscores.Container urlgen={routing.document.score}>
			<layouts.containers.flex flexDirection="column" height="100%" data-testid="brandguard">
				<scoring.Navigation />
				<scoring.Display />
			</layouts.containers.flex>
		</bgscores.Container>
	)
}
